import React, { forwardRef } from 'react';
import { FlatList } from 'react-native';
import { useChatScrollFollow } from '../../hooks/useChatScrollFollow';
import type { TChatMessagesFlatListProps, TChatMessagesListRef } from '../../types';
import { isWelcomeMessage } from '../../utils/welcomeMessage';

export const ChatMessagesFlatList = forwardRef<TChatMessagesListRef, TChatMessagesFlatListProps>(
    function ChatMessagesFlatList({ onScroll, onScrollEndDrag, onMomentumScrollEnd, onContentSizeChange, ...props }, ref) {
        const follow = useChatScrollFollow({
            forwardedRef: ref,
            props: { onScroll, onScrollEndDrag, onMomentumScrollEnd, onContentSizeChange },
        });

        const onlyWelcome = props.data?.length === 1 && isWelcomeMessage(props.data[0]);

        return (
            <FlatList
                {...props}
                data={onlyWelcome ? [] : props.data}
                inverted={onlyWelcome ? false : props.inverted}
                {...follow}
            />
        );
    },
);
